'use client'
import React, { useId } from 'react'
import { UseFormRegisterReturn } from 'react-hook-form'
import FormError from '../FormError'
import Label from '../Label'

export interface ISelectOption {
    value: string
    name: string
}

export interface ISelectProps extends Omit<React.SelectHTMLAttributes<HTMLSelectElement>, 'name'> {
    name?: string
    labelText: string
    options: ISelectOption[]
    isRequired?: boolean
    error?: string
    register?: UseFormRegisterReturn
    inputClass?: string
    placeholder?: string
}

const selectClass = (hasError: boolean) =>
    `border bg-white py-2 border-calm-gray-ultralight h-12 color-harmonic-blue text-[1rem] rounded-xl w-full focus:outline-hidden px-2.5 items-center text-harmonic-blue ${
        hasError ? 'border-jolly-rose' : 'focus:border-secondary hover:border-strong-blue-light'
    }`

/** Lista de opções da loja (padrão do orbit: `labelText`, `isRequired`, `error`, `register`). */
const Select: React.FC<ISelectProps> = ({
    name,
    labelText,
    options,
    className,
    isRequired,
    error,
    register,
    defaultValue = '',
    placeholder = 'Selecione',
    inputClass = '',
    id,
    ...rest
}) => {
    const generatedId = useId()
    const selectId = id ?? generatedId
    const errorId = `${selectId}-error`

    return (
        <Label
            htmlFor={selectId}
            labelText={labelText}
            isRequired={isRequired}
            hasError={Boolean(error)}
            className={className}
        >
            <select
                name={name}
                {...register}
                id={selectId}
                aria-invalid={error ? true : undefined}
                aria-describedby={error ? errorId : undefined}
                {...rest}
                defaultValue={defaultValue as string}
                className={`${inputClass} ${selectClass(Boolean(error))}`}
            >
                <option value="" disabled>
                    {placeholder}
                </option>
                {options.map((option) => (
                    <option key={option.value} value={option.value}>
                        {option.name}
                    </option>
                ))}
            </select>
            {error ? <FormError id={errorId}> {error}</FormError> : null}
        </Label>
    )
}

export default Select
